import React from 'react';

// Internals
import { TODO } from '../../../types';
import Typography from '../../../components/Typography';
import TableCard from '../../../components/TableCard';
import useProviders from '../../../utils/useProviders';

// Antd
import { Avatar, Input, Space } from 'antd';

// Styles
import sharedStyles from './shared.module.scss';
import { get, set } from 'lodash-es';

interface CustomizeProps {
  addresses: object[] | null;
  setAddresses: Function;
  selectedAccount?: any;
}

export default function Customize({ addresses, setAddresses, selectedAccount }: CustomizeProps) {
  const { getImageUsingID } = useProviders();

  const columns = [
    {
      title: 'Wallet address',
      dataIndex: 'wallet_address',
      key: 'wallet_address',
      render: (text: string, record: Record<string, unknown>, index: number) => {
        return (
          <Input
            value={get(addresses, `${index}.wallet_address`)}
            onChange={(e) => {
              const updatedAddresses = Object.assign([], addresses);
              set(updatedAddresses, `${index}.wallet_address`, e.target.value);

              setAddresses(updatedAddresses);
            }}
            allowClear
          />
        );
      },
    },
    {
      title: 'Wallet name',
      dataIndex: 'name',
      key: 'name',
      render: (text: string, record: Record<string, unknown>, index: number) => {
        return (
          <Input
            value={get(addresses, `${index}.name`)}
            onChange={(e) => {
              const updatedAddresses = Object.assign([], addresses);
              set(updatedAddresses, `${index}.name`, e.target.value);

              setAddresses(updatedAddresses);
            }}
            allowClear
          />
        );
      },
    },
  ];

  return (
    <>
      <div className={sharedStyles['wizard-content']}>
        <Space direction="vertical" align="center" size={8} className="fullwidth centered">
          <Avatar
            size={45}
            style={{
              margin: '2rem 0 1.5rem 0',
            }}
            src={selectedAccount.image}
          />

          <Typography type="text_lg" weight="medium">
            Sync with {selectedAccount.name}
          </Typography>

          <Typography type="text_sm" color="secondary" style={{ marginBottom: '2rem' }}>
            Customize the data below to speed up your accounting process in the future
          </Typography>
        </Space>
      </div>

      <div className={sharedStyles['table-card']}>
        <TableCard
          checkboxSelection={false}
          dataSource={addresses}
          columns={columns}
          showCardActions={false}
          title={null}
        />
      </div>
    </>
  );
}
